import { useFormContext, useController } from 'react-hook-form';

import { LANGUAGE_MAP, languages } from '@data';
import { Select } from '@ui';
import { useTranslate } from '@i18n';

export const LanguagePicker = () => {
    const { control } = useFormContext();
    const { field } = useController({ name: 'locale', control });
    const { value, onChange } = field;
    const t = useTranslate();

    return (
        <Select
            options={languages.map((l) => ({ value: l, label: LANGUAGE_MAP[l] }))}
            selectedValue={value}
            onChange={(vals) => onChange(vals[0])}
            label={t('user_settings.language_label')}
        />
    );
};
